export class Contact {
	name: string;
	email: string;
}